export enum SearchType {
  repairAndMainenance = 'RepairAndMaintenance',
  expense = 'Expense',
  accountsPayable = 'AccountsPayable',
}

export interface SearchRequest {
  assetIds?: string[];
  /** Service request ids (e.g. dashboard drill-down scope). */
  ids?: string[];
  page: number;
  pageSize: number;
  type?: SearchType;
  /** Revamp list tab key for tab-scoped saved filters (AP / Expense / RM). */
  tab?: string;
  keyword?: string;
  WebStatus?: string[];
  AccountPayableFilters?: { [key: string]: any };
  repairAndMaintenaceFilters?: { [key: string]: any };
  expenseFilters?: { [key: string]: any };
  /** RM vendor tab drill-down — backend applies `ApplyVendorPendingActionFilters` when non-empty. */
  vendorMyPendingActions?: string[];
}

export interface SearchRequestByDashboard {
  companyIds: string[],
  parts: string[],
  type?: any;
  dashboardFilterTypeModel?: {};
  date?: {};
}

export interface DashboardServiceRequestSearchRequest {
  page: number;
  pageSize: number;
  ids: string[];
  type: SearchType | 'None';
  keyword?: string;
}

export interface SearchResponse<T> {
  currentPageIndex: number;
  currentPage: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  onFirstPage: boolean;
  onLastPage: boolean;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  items: T[];
}

export type Url = 'servicerequest' | 'vendor' | 'category';
